<template>
  <b-container class="px-3 mx-0" fluid="true">
    <b-row class="pt-2 pb-2">
      <b-col cols="6" class="pr-2 pl-0">
        <DateTimePicker
            v-model="startDateValue"
            date-type="LocalDate"
            format="L"
            :label="$tr('startDate','Start Date')"
            :validated-field="startDate"
        >
        </DateTimePicker>

      </b-col>
      <b-col cols="6"  class="pr-0 pl-2">
        <DateTimePicker
            v-model="endDateValue"
            date-type="LocalDate"
            format="L"
            :label="$tr('endDate','End Date')"
            :validated-field="endDate"
        >
        </DateTimePicker>
      </b-col>
    </b-row>
    <b-row v-if="dateErrorMessage && startDateValue && endDateValue">
      <b-col>
        <small class="form-text text-danger pt-2">
          {{$tr('dataDialog.date.earlier','End date cannot be earlier than the starting date.')}}
        </small>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import FormsLoader from "@/components/forms/FormsLoader";
import FormsActions from "@/components/forms/FormsActions";
import FormsAI from "@/components/forms/FormsAI";
import ReportFilterSpec from "@/server/com/silkplm/engine/reports/filters/ReportFilterSpec";
import DateTimePicker from "@/components/inputs/DateTimePicker.vue";
import moment from "moment-timezone";

moment.suppressDeprecationWarnings = true;

export default {
  name: "DateFilterActivityInput",
  components: {DateTimePicker},
  beforeMount() {
  },
  mounted() {
    let x = 5;
  },
  props: {
    filter: {default: null, type: ReportFilterSpec},
  },
  watch: {
    startDateValue: async function (val) {
      this.dateErrorMessage = moment(val?.value).isAfter(moment(this.endDateValue?.value));
      let tmpObject = {
        startDateExpectedValue: val,
        endDateExpectedValue: this.endDateValue,
        filterType: "DateFilterSpec"
      }
      this.$emit('data-updated', this.filter.id, tmpObject);
    },
    endDateValue: async function (val) {
      this.dateErrorMessage = moment(val?.value).isBefore(moment(this.startDateValue?.value));
      let tmpObject = {
        startDateExpectedValue: this.startDateValue,
        endDateExpectedValue: val,
        filterType: "DateFilterSpec"
      }
      this.$emit('data-updated', this.filter.id, tmpObject);
    },
  },
  methods: {
    async edit() {
      if (this.foreignForm && this.validatedField.value) {
        let entity = await Rpc.Forms.getEntity(this.foreignForm.formClassLong, this.validatedField.value)
        await FormsActions.edit(entity);
      }
    },

  },

  data: () => ({
    hasAccessToList: false,
    options: [],
    idToLabel: new Map(),
    editorMode: false,
    readOnly: true,
    loadInProgress: false,
    currentOpt: {},
    valueSetFromList: false,
    valueSetFromCurrent: false,
    nullAdded: false,
    listLoaded: false,
    optionsList: [],
    nullRow: {value: null, text: ''},
    selectedValue: null,
    formattedValue: "",

    dateErrorMessage: false,
    title: "",
    resolve: null,
    result: null,
    startDate: null,
    startDateValue: null,
    endDate: null,
    endDateValue: null,
  })
}
</script>

<style scoped>

</style>